import SEO from "../designSystem/SEO";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import ProtectionAdviceImage from "../../assets/images/protection_01.png";
import ProtectionPlanningImage from "../../assets/images/protection_02.png";
import { ReactComponent as ResidentialIcon } from "../../assets/icons/capc_icons_trusted_providers.svg";
import { ReactComponent as PersonalIcon } from "../../assets/icons/capc_icons_tailored_advice.svg";
import { ReactComponent as ProfessionalIcon } from "../../assets/icons/capc_icons_ongoing_peace_of_mind.svg";
import Hero from "../designSystem/Hero";

const highlights = [
  {
    title: "Tailored Advice",
    icon: PersonalIcon,
    text: "Personalised recommendations based on your circumstances, helping you choose the right level of protection.",
  },
  {
    title: "Trusted Providers",
    icon: ResidentialIcon,
    text: "We work with a range of leading UK insurers to help find suitable protection solutions at competitive premiums.",
  },
  {
    title: "Ongoing Peace of Mind",
    icon: ProfessionalIcon,
    text: "We'll explain your options clearly, arrange your cover and be on hand if your needs change in the future.",
  },
];

const ProtectionPage = () => (
  <main>
    <SEO
      title="Protection Services"
      description="Personal protection advice covering life insurance, critical illness, income protection, mortgage protection and business protection."
      path="/protection"
    />
    <Hero wantOverlay={false}>
      <div className="content-container">
        <div className="column gap-m align-center">
          <div className="nav-text text-secondary-1 uppercase">Our services</div>
          <h1 className="text-primary-1 text-center">Protection</h1>
          <div className="content text-primary-2 text-center">
            Protecting your home, your income, your business and your loved ones
            is just as important as securing the right mortgage. Having the
            right protection in place can provide financial security and peace
            of mind should the unexpected happen.
          </div>
          <PrimaryButtonSmall text="contact us" />
        </div>
      </div>
    </Hero>

    <section className="background-container bg-white">
      <div className="content-container grid2 gap-xxxxxl grid-stretch">
        <div className="column gap-l">
          <h3 className="text-primary-2">Why Choose CAPC for Protection?</h3>{" "}
          <div className="column gap-m">
            <div className="content text-primary-2">
              At CAPC, we provide tailored protection advice alongside our
              mortgage services. From life insurance, critical illness cover and
              income protection to business protection solutions such as Key
              Person Insurance, Shareholder Protection and Relevant Life Cover,
              we'll take the time to understand your situation and recommend
              cover that fits your lifestyle, business needs, budget and
              long-term financial goals.
            </div>
            <div className="content text-primary-2">
              Whether you're looking to protect your family, cover your mortgage
              repayments, safeguard your income or ensure your business can
              continue operating if key people become ill or pass away, there
              are a range of protection and insurance products available to suit
              your needs. Choosing the right cover can be complex, but expert
              advice ensures you have the protection that's right for your
              personal and business circumstances.
            </div>
          </div>
        </div>
        <img
          src={ProtectionAdviceImage}
          alt="Couple meeting an adviser to discuss financial protection"
          className="hero-image"
        />
      </div>
    </section>

    <section className="background-container bg-primary-2">
      <div className="content-container grid3 gap-xxxxl">
        {highlights.map(({ title, icon: Icon, text }) => (
          <article className="column gap-xl align-center" key={title}>
            <Icon aria-hidden="true" />
            <div className="column gap-m align-center">
              <div className="subtitle-semibold text-white text-center">
                {title}
              </div>
              <div className="content text-white text-center">{text}</div>
            </div>
          </article>
        ))}
      </div>
    </section>
    <section className="background-container bg-white">
      <div className="content-container grid2 gap-xxxxxl grid-stretch">
        <img
          src={ProtectionPlanningImage}
          alt="Couple reviewing financial protection documents together"
          className="hero-image"
        />
        <div className="column gap-l">
          <h3 className="text-primary-2">How We Can Help</h3>{" "}
          <div className="column gap-m">
            <div className="content text-primary-2">
              Our advisers will guide you through your options with clear,
              straightforward advice, ensuring you and your family have the
              right financial protection in place.
            </div>
            <ul className="content text-primary-2 column gap-s">
              <li>Life insurance</li>
              <li>Critical illness cover</li>
              <li>Income protection</li>
              <li>Family income benefit</li>
              <li>Buildings and contents insurance</li>
              <li>Mortgage protection</li>
              <li>Business protection</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default ProtectionPage;
